"use client";
import { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { trimText } from "@/lib/trimText";
import Image from "next/image";
import { Badge } from "@/components/ui/badge";
import Link from "next/link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { formatCurrency } from "@/utils/formatCurrency";

const AuthorBooks = ({ authorBooks }) => {
  const [books, setBooks] = useState([]);

  useEffect(() => {
    setBooks(authorBooks);
  }, [authorBooks]);

  return (
    <Card className="min-w-[280px] h-fit overflow-hidden">
      <CardHeader>
        <CardTitle className="text-lg text-custom-text-blue ">
          Author Books
        </CardTitle>
      </CardHeader>
      <Separator></Separator>
      <CardContent>
        <div className="flex flex-col divide-y">
          {books?.slice(0, 4)?.map((book) => (
            <Link
              href={`/product/${book?.slug}`}
              className="flex gap-2 py-2"
              key={book?._id}
            >
              <Image
                src={book?.images?.[0]}
                alt={book?.title}
                width={50}
                height={50}
              />
              <div className="w-full">
                <h1 className="text-sm font-medium text-custom-black ">
                  {trimText(book?.title, 25)}
                </h1>
                <p className="mt-1 text-xs text-gray-600">
                  {trimText(book?.author?.name, 20)}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-start flex-col">
                    <p className="text-sm text-custom-text-blue  font-medium">
                      {formatCurrency(Math.round(book?.discountedPrice))}
                    </p>
                    <p className="text-sm text-[#7d7373] line-through">
                      {formatCurrency(book?.price)}
                    </p>
                  </div>
                  {book?.discount === 0 ? null : (
                    <Badge className="bg-[#005c7a] select-none text-white text-xs">
                      {Math.ceil(book?.discount)}% off
                    </Badge>
                  )}
                </div>
              </div>
            </Link>
          ))}
        </div>
      </CardContent>
      <CardFooter className="p-0">
        <Link
          href={`/author-books?search=${books?.[0]?.author?.name}`}
          className={cn("mx-auto", books?.length > 4 ? "block" : "hidden")}
        >
          <Button className="mb-4">See all books</Button>
        </Link>
      </CardFooter>
    </Card>
  );
};

export default AuthorBooks;
